import { render, staticRenderFns } from "./activityCourses.html?vue&type=template&id=c9074be4&scoped=true&external"
import script from "./activityCourses.vue?vue&type=script&lang=js"
export * from "./activityCourses.vue?vue&type=script&lang=js"
import style0 from "./activityCourses.css?vue&type=style&index=0&id=c9074be4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9074be4",
  null
  
)

export default component.exports